import React from 'react';

import type { ExtensionHandlerProps } from '@confluence/fabric-extension-lib/entry-points/commonExtensionTypes.ts';
import { PageTreeMacroHandler } from '@confluence/pagetree-macro/entry-points/PageTreeMacroRenderer.ts';
import type { PageTreeMacroParams } from '@confluence/pagetree-macro/entry-points/PageTreeMacroRenderer.ts';

import { NestedAdfRendererWrapperProvider } from '../NestedAdfRendererWrapper.tsx';

type PageTreeExtensionHandlerProps = ExtensionHandlerProps & {
	Renderer: React.FC<any>;
	appearance?: string;
	macroParams?: PageTreeMacroParams;
};

export const PageTreeExtensionHandler = ({
	Renderer,
	appearance,
	macroParams,
	...macroDefaultProps
}: PageTreeExtensionHandlerProps): React.JSX.Element => (
	<NestedAdfRendererWrapperProvider Renderer={Renderer} appearance={appearance}>
		{(RendererWrapper) => (
			<PageTreeMacroHandler
				macroDefaultProps={macroDefaultProps}
				macroParams={macroParams}
				RendererWrapper={RendererWrapper}
			/>
		)}
	</NestedAdfRendererWrapperProvider>
);
